///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { toggleExclude } from "../slices/analyticsSlice";
import { getDivisionCurrency } from "./laneViewColumns";
import messages from "./messages";
import { cellUnit, controls } from "./types";

export const carrierViewColumns = [
  {
    header: messages.carrier.defaultMessage,
    field: "carrierName",
    cellUnit: cellUnit.none,
    unitLeft: true,
    filter: true,
    left: true,
    control: controls.none,
    isDraggable: false
  },
  {
    header: messages.vol.defaultMessage,
    field: "volume",
    cellUnit: cellUnit.none,
    unitLeft: true,
    rangeFilter: true,
    right: true,
    control: controls.none,
    isDraggable: false
  },
  {
    header: messages.cost.defaultMessage,
    field: "cost",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.margin.defaultMessage,
    field: "margin",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.rate.defaultMessage,
    field: "rate",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: "",
    field: "exclude",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.button,
    isDraggable: false,
    buttonClick: toggleExclude
  }
];

export default carrierViewColumns;
